import { SPORTS, LEAGUES_BY_SPORT } from "../../constants/sports";
import { LEAGUES } from "../../constants/leagues";
import { LeagueLogo } from "../shared/LeagueLogo";

const LEAGUE_BY_CODE = Object.fromEntries(LEAGUES.map((l) => [l.code, l]));

// Sport row (Baseball and Football are configured; Basketball/Hockey remain disabled "Coming
// soon") above a League row scoped to the active sport, using the existing configured league
// data.
export const SportLeagueNav = ({ activeSport, activeLeague, onSportChange, onLeagueChange }) => {
  const leagueCodes = LEAGUES_BY_SPORT[activeSport] || [];

  return (
    <div data-testid="sport-league-nav" className="flex flex-col gap-3">
      <div className="flex gap-6 border-b border-white/10" data-testid="sport-tabs">
        {SPORTS.map((sport) => {
          const active = sport.enabled && sport.code === activeSport;
          return (
            <button
              key={sport.code}
              type="button"
              disabled={!sport.enabled}
              title={sport.enabled ? undefined : "Coming soon"}
              data-testid={`sport-tab-${sport.code}`}
              onClick={() => sport.enabled && onSportChange(sport.code)}
              className={`relative flex items-center gap-1.5 pb-3 font-heading text-base uppercase tracking-wide transition-colors ${
                !sport.enabled ? "cursor-not-allowed text-zinc-700" : active ? "text-white" : "text-zinc-500 hover:text-zinc-300"
              }`}
            >
              {sport.label}
              {!sport.enabled && (
                <span data-testid={`sport-tab-${sport.code}-soon`} className="rounded-full bg-white/5 px-1.5 py-0.5 font-mono text-[9px] normal-case tracking-normal text-zinc-600">
                  Soon
                </span>
              )}
              {active && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-eb-accent" />}
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-2" data-testid="league-tabs">
        {leagueCodes.map((code) => {
          const league = LEAGUE_BY_CODE[code];
          if (!league) return null;
          const active = code === activeLeague;
          return (
            <button
              key={code}
              type="button"
              data-testid={`tab-${code.toLowerCase()}`}
              onClick={() => onLeagueChange(code)}
              className={`flex items-center gap-1.5 rounded-md border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
                active ? "border-eb-accent bg-eb-accent/10 text-white" : "border-white/10 text-zinc-400 hover:border-white/30 hover:text-zinc-200"
              }`}
            >
              <LeagueLogo code={code} label={league.label} size={16} testId={`league-logo-${code.toLowerCase()}`} />
              {league.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
